import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Label,
  InputGroup,
  Input,
  Button
} from 'reactstrap'

class FieldTextarea extends Component {
  constructor(props) {
    super(props)

    this.state = {
      fieldType: this.props.cardField.fieldType
    }

    this.returnValue = this.returnValue.bind(this)
  }

  returnValue() {
    return this[this.props.cardField.id].value
  }

  render() {
    const fieldClassName = `card-field field-text ${(this.props.cardField.fieldClassName ? this.props.cardField.fieldClassName : '')}`

    return this.props.isEditing || this.props.cardType === 'always-on' ? <div className={fieldClassName}>
      <Label for={this.props.cardField.id}>
        {this.props.cardField.fieldLabel}
      </Label>
      {this.props.cardField.fieldSublabel && <p className='form-control-sublabel'>{this.props.cardField.fieldSublabel}</p>}
      <InputGroup className='mb-3'>
        <Input
          type='textarea'
          key={this.props.cardField.id}
          id={this.props.cardField.id}
          placeholder={this.props.cardField.fieldPlaceholder}
          defaultValue={this.props.cardField.fieldValue}
          required={this.props.cardField.fieldRequired}
          rows={this.props.cardField.textareaRows}
          innerRef={el => { this[this.props.cardField.id] = el }}
        />
      </InputGroup>
    </div> : <div className={fieldClassName}>
      <Label className="mb-0" for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
      <div className="mb-3" dangerouslySetInnerHTML={{ __html: this.props.cardField.fieldValue && this.props.cardField.fieldValue.replace(/\r?\n/g, '<br />') }} />
    </div>
  }
}

FieldTextarea.propTypes = {
  cardField: PropTypes.object,
  isEditing: PropTypes.bool,
  cardType: PropTypes.string
}

FieldTextarea.defaultProps = {
  cardField: {
    cardSublabel: ''
  }
}

export default FieldTextarea


// WEBPACK FOOTER //
// ./src/components/EditableCard/FieldTextarea.js